import React, { Suspense, lazy } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const ImpersonationBanner = lazy(() =>
  import('./ImpersonationBanner').then((m) => ({ default: m.ImpersonationBanner })),
);

/** Loads impersonation UI only for platform admins (separate chunk). */
export default function AdminImpersonationBanner() {
  const { isAdmin, impersonatedWorkspaceId, impersonationMode } = useAuth();

  if (!isAdmin || !impersonatedWorkspaceId || !impersonationMode) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ImpersonationBanner />
    </Suspense>
  );
}
